<template>

<span>
  <span v-if="display">{{$store.getters.raw_to_amt(value, cur)}}</span>
  <input v-else :value="$store.getters.raw_to_amt(value, cur)" type='number' :step="cur==='USD' || cur==='CAD' ? '0.01' : '1'" :required="required" @keyup.enter="$event.target.blur()" @blur="blur($event.target.value)" class='cur_input'  />
</span>

</template>

<script>

export default {
    props: {
	value   : {
	    type: Number, String
	},
	currency: {
	    type: String,
	},
	required: {
	    type: Boolean
	},
	display: {
	    type: Boolean
	},
	parent: {
	    type: Object
	},
	currency_field: {
	    type: String
	},
    },
    methods: {
	blur: function(amt) {
	    this.$emit("input", this.$store.getters.amt_to_raw(amt, this.cur))
	}
    },
    computed: {
	cur: function() {
	    if(this.parent && this.currency_field) {
		return this.parent[this.currency_field]
	    } else {
		return this.currency
	    }
	}
    }
}
  
</script>

<style scoped>

.currency_input {
    text-align: right;
    width: 100px !important;
}

</style>
